//@ts-check

/** @type {string|null} */
let accessToken = null;

/** @type {Set<(token: string|null) => void>} */
const listeners = new Set();

/**
 * @returns {string|null}
 */
export function getAccessToken() {
  return accessToken;
}

/**
 * @param {string|null} token
 */
export function setAccessToken(token) {
  accessToken = token;
  listeners.forEach((listener) => listener(token));
}

/**
 * @param {(token: string|null) => void} listener
 * @returns {() => void}
 */
export function subscribeAccessToken(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
